<!-- 
  详情页 - 业绩分配
  props:
    id: 详情id
 -->

<template>
  <div class="v-tabs performance">
    <div class="box">
      <h4 class="title">分配详情</h4>
      <ul class="desc-list">
        <li class="item">
          <span class="label">分配总人数：</span>
          <span class="text">{{count}}人</span>
        </li>
        <li class="item">
          <span class="label">项目总金额：</span>
          <span class="text">{{amount}}{{unit}}</span>
        </li>
        <li class="item">
          <span class="label">已分配金额：</span>
          <span class="text" :class="{red: isRed}">{{fixedAmount(totalMoney)}}{{unit}}</span>
        </li>
        <li class="item">
          <span class="label">未分配金额：</span>
          <span class="text" :class="{red: isRed}">{{fixedAmount(unMoney)}}{{unit}}</span>
        </li>
        <li class="item">
          <span class="label">已分配比例：</span>
          <span class="text">{{totalPercent | fixed2}}%</span>
        </li>
        <li class="item">
          <span class="label">未分配比例：</span>
          <span class="text">{{unPercent | fixed2}}%</span>
        </li>
      </ul>
    </div>
    <div class="box">
      <h4 class="title">分配列表</h4>
      <el-table
        :data="tableData"
        :class="{active: editStatus}"
        highlight-current-row
        style="width: 100%">
        <el-table-column
          label="头像"
          width="90">
          <template slot-scope="scope">
            <div class="avatar">
              <img width="50" height="50" :src="scope.row.userAvatar">
              <i class="ico web-icon-ismain" v-if="scope.row.isSign"></i>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="员工姓名"
          width="140"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="text">{{scope.row.userName}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="分配比例"
          width="160"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-show="!editStatus" class="normal">{{scope.row.rate}}</span>
            <input v-show="editStatus" v-model.lazy.number="scope.row.rate" @change="handleChange(scope.$index, 'rate')" type="text" class="v-input">
            <span class="text">%</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="'分配金额'+unit"
          width="160"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="normal" :class="{red: isRed}" v-show="!editStatus">{{scope.row.amount}}</span>
            <input v-show="editStatus" v-model.lazy.number="scope.row.amount" @change="handleChange(scope.$index, 'amount')" type="text" class="v-input">
          </template>
        </el-table-column>
        <el-table-column
          label="操作">
          <template slot-scope="scope">
            <a href="javascript:;" class="del" @click="del(scope.$index, scope.row.id)">删除</a>
          </template>
        </el-table-column>
      </el-table>
      <div class="option" v-if="isEdit" @click="editStatus=!editStatus">
        <i class="el-icon-edit"></i>
        <span class="text">
          <template v-if="editStatus">退出</template>编辑
        </span>
      </div>
      <div class="button-group" v-if="editStatus">
        <el-button type="primary" size="small" @click="addPerformance">添加分配人</el-button>
        <el-button type="primary" size="small" @click="handleSubmit">保存</el-button>
      </div>
    </div>

    <!-- 选择分配人 -->
    <div class="custom-dropbox" v-if="dialogVisible" v-clickoutside="closeDialog">
      <v-dropbox @staff="getStaff"></v-dropbox>
    </div>
  </div>
</template>

<script>
import * as api from 'src/api'
import { Message } from 'element-ui'
import Clickoutside from 'element-ui/lib/utils/clickoutside'
import vDropbox from 'components/common/dropbox'

export default {
  created () {
    this.getList()
  },
  props: {
    id: {
      type: Number
    }
  },
  data () {
    return {
      dialogVisible: false,
      // 编辑状态
      editStatus: false,
      // 分配总人数
      count: 0,
      // 项目总金额
      amount: 0,
      // 货币单位
      unit: '元',
      // 是否可以编辑
      isEdit: 0,
      tableData: [],
      dataForSend: [],
      // 要删除的数据
      delIds: [],
      totalPercent: 0, // 已分配比例
      totalMoney: 0, // 已分配金额
      isRed: false, // 是否红冲
      amountPrecision: 2 // 金额小数位数
    }
  },
  computed: {
    // 未分配金额
    unMoney () {
      return (this.amount - this.totalMoney)
    },
    // 未分配比例
    unPercent () {
      return (100 - this.totalPercent)
    }
  },
  methods: {
    getList () {
      let url = '/contractPerformanceApi/getList.html'
      let params = {
        contractId: this.id
      }
      api.post(url, params, (data) => {
        this.count = data.result.count
        this.amount = data.result.amount
        this.unit = data.result.unit
        this.isEdit = data.result.isEdit
        this.isRed = data.isRed
        this.dataForSend = data.result.performanceList.map(item => {
          item.amount = item.amount
          return item
        })
        this.amountPrecision = data.result.amountPrecision
        this.formatData()
      })
    },
    // 删除
    del (index, id) {
      // 在显示列表中，移除该数据
      this.dataForSend.splice(index, 1)
      this.formatData()

      // 将被删除的id添加到delIds
      if (id !== undefined && this.delIds.indexOf(id) === -1) {
        this.delIds.push(id)
      }
    },
    // 发送数据
    sendData () {
      let url = '/contractPerformanceApi/save.html'
      let params = {
        contractId: this.id,
        itemList: this.dataForSend.map(item => {
          return {
            id: item.id,
            targetUserId: item.userId,
            rate: item.rate,
            amount: item.amount,
            operate: 'u'
          }
        })
      }
      // 将被删除的数据添加进去
      if (this.delIds.length) {
        this.delIds.forEach(id => {
          params.itemList.push({
            id: id,
            operate: 'd'
          })
        })
      }
      api.post(url, params, (data) => {
        this.editStatus = false
        this.getList()
        this.message()
      })
    },
    // 提交前校验
    handleSubmit () {
      if (Math.abs(this.totalPercent - 100) < 0.0001) {
        this.sendData()
      } else {
        this.message('还有未分配的业绩', 'error')
      }
    },
    // 添加分配人
    addPerformance () {
      setTimeout(() => {
        this.dialogVisible = true
      }, 10)
    },
    // 获取已选择的分配人
    getStaff (id, name, avatar) {
      // 生成一个只包含userId的数组
      let arr = this.dataForSend.map(item => item.userId)

      // 如果该用户已存在，则不再进行添加
      if (arr.indexOf(id) === -1) {
        this.dataForSend.push({
          userId: id,
          userName: name,
          userAvatar: avatar,
          rate: 0,
          amount: 0
        })
        this.formatData()
      } else {
        this.message('已添加该用户!', 'warning')
      }
    },
    closeDialog () {
      if (this.dialogVisible) {
        // 判断是否存在级联选择框，不存在或者存在时display为none时为真
        if (!document.querySelector('.el-cascader-menus') || document.querySelector('.el-cascader-menus').style.display) {
          this.dialogVisible = false
        }
      }
    },
    // 格式化数据
    formatData () {
      this.tableData = this.dataForSend.map(item => {
        // 复制一个新对象
        let newItem = JSON.parse(JSON.stringify(item))

        newItem.rate = Number(newItem.rate).toFixed(2)
        newItem.amount = Number(newItem.amount)
        return newItem
      })
    },
    // 监听编辑状态下的改动
    handleChange (index, type) {
      let row = this.dataForSend[index] = this.tableData[index]
      this.checkOutside(row, (result) => {
        if (type === 'rate') {
          row.rate = Math.abs(row.rate) // 取正

          // 修改对应的金额
          row.amount = (this.amount * (result || row.rate) / 100)
        } else {
          // 取负
          if (row.amount > 0) {
            row.amount = 0 - row.amount
          }

          // 修改对应的比例
          row.rate = ((result || row.amount) / this.amount * 100)
        }
        this.autoCompile()
      })
    },
    // 检测所输入的值是否超出边界
    checkOutside (row, cb) {
      setTimeout(() => {
        if (this.totalPercent > 100.0001) {
          this.message('分配比例超出范围', 'warning')

          // 将剩余比例分配给该字段
          row.rate = (100 + row.rate) - this.totalPercent
          cb(row.rate)
        } else if (this.totalMoney < this.amount) {
          this.message('分配金额超出范围', 'warning')

          // 将剩余金额分配给该字段
          row.amount = (this.amount + row.amount) - this.totalMoney
          row.amount = Number(row.amount.toFixed(this.amountPrecision)) // 处理浮点数计算精度
          cb(row.amount)
        } else {
          cb()
        }
      }, 20)
    },
    // 剩余一行未填写时，自动补全
    autoCompile () {
      let i = 0
      let loc
      this.dataForSend.forEach((item, index) => {
        if (item.rate === 0) {
          i++
          loc = index
        }
      })
      if (i === 1) {
        this.$nextTick(() => {
          let lastPercent = 100 - this.totalPercent
          this.dataForSend[loc].rate = lastPercent
          let lastMoney = this.amount - this.totalMoney
          this.$set(this.dataForSend[loc], 'amount', lastMoney)
          this.formatData()
        })
        return
      }
      this.formatData()
    },
    // message
    message (msg, type) {
      Message({
        type: type || 'success',
        message: msg || '操作成功'
      })
    },
    fixedAmount (val) {
      return Math.abs(val.toFixed(this.amountPrecision))
    }

  },
  watch: {
    editStatus () {
      // 退出编辑模式时，重新获取列表数据
      if (!this.editStatus) {
        this.getList()
      }
    },
    // 监听数据变化，并更新已分配的值
    tableData: {
      handler (val) {
        let p = 0
        let m = 0
        this.dataForSend.forEach(item => {
          p += Number(item.rate)
          m += Number(item.amount)
        })
        this.totalPercent = p
        this.totalMoney = m
      },
      deep: true
    }
  },
  filters: {
    fixedMinus (val) {
      val = val.toFixed(2)
      if (val > 0) {
        val = 0 - val
      }
      return val
    },
    fixed2 (val) {
      return Math.abs(val.toFixed(2))
    }
  },
  components: {
    vDropbox
  },
  directives: { Clickoutside }
}
</script>

<style lang="less" scoped>
  @import '../../../assets/less/variable.less';
  .performance {
    .box {
      padding: 15px 0;
      position: relative;
      .title {
        color: @bg-orange;
        font-size: 14px;
        line-height: 1;
        padding-left: 20px;
        border-left: 13px solid @bg-orange;
      }
      .desc-list {
        font-size: 0;
        margin-top: 10px;
        .item {
          display: inline-block;
          width: 50%;
          font-size: 14px;
          line-height: 2.4;
          .label {
            width: 110px;
            text-align: right;
            display: inline-block;
          }
          .text {
            color: @light-gray;
            display: inline-block;
          }
        }
      }
      .el-table {
        margin-top: 20px;
        .avatar {
          width: 50px;
          height: 50px;
          position: relative;
          margin: 5px 0;
          img {
            display: block;
            width: 50px;
            height: 50px;
            border-radius: 50%;
          }
          .ico {
            position: absolute;
            width: 14px;
            height: 14px;
            font-size: 12px;
            line-height: 14px;
            border-radius: 50%;
            background-color: @bg-orange;
            color: #fff;
            text-align: center;
            right: 0;
            bottom: 0;
          }
        }
        .v-input {
          display: inline-block;
          width: 80px;
          padding-left: 10px;
          line-height: 28px;
          border: 1px solid #ededed;
          border-radius: 2px;
          box-sizing: border-box;
        }
        .del {
          display: none;
          color: @bg-red;
          &:hover {
            text-decoration: underline;
          }
        }
        &.active {
          .del {
            display: inline-block;
          }
        }
      }
      .option {
        position: absolute;
        right: 10px;
        top: 15px;
        cursor: pointer;
        font-size: 13px;
        color: @primary;
      }
      .button-group {
        margin-top: 10px;
        text-align: right;
      }
    }
    .custom-dropbox {
      width: 360px;
      height: 450px;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-top: -200px;
      margin-left: -225px;
      z-index: 501;
    }
    .red {
      color: @bg-red!important;
    }
  }
</style>


// WEBPACK FOOTER //
// red-performance.vue?52bb9681